import React, { FC } from "react";
import { Height } from "@baseTypes/baseType";
import { useTypedSelector } from "@hooks/useTypedSelector";
import { IdlesSliceState } from "../../../../../../store/reducers/dashboard/works/idles";
import Container from "../../../../../../components/elements/container/Container";
import st from './index.module.scss';
import stBase from "../stylesBase.module.scss";
import FlexLine from "../../../../../../components/elements/flexLine/FlexLine";
import IdlesStackedBarsChart
    from "./components/IdlesStackedBarsChart/IdlesStackedBarsChart";
import {
    useElementsToDrawByPeriod
} from "./hooks/useElementsToDraw";
import IdlesStackedBarsLegend
    from "./components/IdlesStackedBarsLegend/IdlesStackedBarsLegend";
import { isEmpty } from "lodash";
import { formatDateWithTemplate } from "@utils/format/date";
import { WorkDisplayPeriod } from "@baseTypes/service/dashboard/IWorksDashboardService";
import useDashboardPageSize from "@hooks/useDashboardPageSize";

type IdlesChartProps = {
    period: WorkDisplayPeriod
}

export const IdleTypes = {
    planed: 'Плановые простои',
    unplanned: 'Внеплановые простои'
}

const Index: FC<IdlesChartProps> = (props) => {
    const { period } = props;

    const {
        data
    } = useTypedSelector<IdlesSliceState>(state => state.idlesDetalization)

    const elementsToDraw = useElementsToDrawByPeriod(period, data)
    const { selectedDate } = useTypedSelector(state => state.selectedDate)

    const dashboardWidth = useDashboardPageSize()

    return (
        <Container className={st['chart']}>
            <FlexLine className={st['chart__header']}>
                <span className={stBase['chart__title']}>Простои</span>
                {period === 'today' && dashboardWidth !== 'small' &&
                    <span className={st['chart__header__date']}>
                        {formatDateWithTemplate(selectedDate?.getTime() || Date.now(), 'DD MMMM')}
                    </span>
                }
            </FlexLine>
            <Container className={st['chart__container']} height={Height.Full}>
                {
                    isEmpty(elementsToDraw)
                        ? <h3 className={st['chart__empty']}>Нет данных за сегодня. Укажите причины простоя.</h3>
                        : <div className={period === 'today' ? st['chart__idles'] : ''}>
                            <IdlesStackedBarsChart period={period} elements={elementsToDraw} />
                            {period === 'today' && dashboardWidth !== 'small' && <IdlesStackedBarsLegend idle={elementsToDraw[0]} />}
                        </div>
                }
            </Container>
        </Container>
    )
}

export default Index;